import { picoapp } from "picoapp";

import { billboardSlider, biosSlider } from "../components/vote-slider";
import addons from "../components/addons";
import aboutContent from "../components/about-content";
import aboutSlider from "../components/about-slider";
import accountLogin from "../components/accountLogin";
import additionalProductInformation from "../components/additional-product-information";
import animateText from "../components/animate-text";
import animatedDetails from "../components/animated-details";
import banner from "../components/banner";
import basicCollection from "../components/basic-collection";
import brandCarousel from "../components/brand-carousel";
import bundleCarouselMobile from "../components/bundle-carousel-mobile";
import cluster from "../components/cluster";
import collectionProductImage from "../components/collection-product-image";
import collectionSlider from "../components/collection-slider";
import columnSlider from "../components/column-slider";
import comparePrice from "../components/compare-price";
import compareProducts from "../components/compare-products";
import contactForm from "../components/contact-form";
import corpContactForm from "../components/corpContactForm";
import faqShippingDetails from "../components/faqShippingDetails";
import dynamicImageToggle from "../components/dynamic-image-toggle";
import dynamicBackgroundToggle from "../components/dynamic-background-toggle";
import collectionGrid from "../components/collection-grid";
import footer from "../components/footer";
import freeShippingLabel from "../components/free-shipping-label";
import geolocationModal from "../components/geolocation-modal.js";
import itemsGroup from "../components/items-group";
import infographic from "../components/infographic";
import instagram from "../components/instagram";
import lpVideoSection from "../components/lp-video-section";
import newsletterForm from "../components/newsletter";
import newsletterSlide from "../components/newsletterSlide";
import options from "../components/options";
import otherProducts from "../components/other-products";
import playPauseAnimation from "../components/play-pause-animation";
import pressSlider from "../components/press-slider";
import product from "../components/product";
import productBundle from "../components/product-bundle";
import productCard from "../components/product-card";
import productCardSG from "../components/product-card-sg";
import productCardsMobile from "../components/product-cards-mobile";
import productCardImages from "../components/product-card-images";
import productMixedBundle from "../components/product-mixed-bundle";
import productInfoAccordion from "../components/product-info-accordion";
import productItem from "../components/product-item";
import productItems from "../components/productItems";
import productReviewsHeader from "../components/product-reviews-header";
import productSelection from "../components/product-selection";
import productSelectionGC from "../components/product-selection-gc";
import productCarousel from "../components/product-carousel";
import productUpsell from "../components/product-upsell";
import reviewsSlider from "../components/reviews-slider";
import slider from "../components/slider";
import swatchButton from "../components/swatch-button";
import toggle from "../components/toggle";
import smoothScroll from "../components/smooth-scroll";
import video from "../components/video";
import warrantyForm from "../components/warrantyForm";
import privacyForm from "../components/privacyForm";
import window from "../components/window";
import price from "../components/price";
import productLoader from "../components/product-loader";
import productHighlight from "../components/product-highlight";
import customerOrder from "../components/customer-order";
import quantitySelector from "../components/quantity-selector";
import oldStickyProductBar from "../components/sticky-product-bar";

import { getTablescapeState } from "../../tablescape/state";

const state = {
  filter: null,
  productCards: {},
  currentVariant: {},
  quantity: 1,
  ...getTablescapeState(true),
};

const components = {
  addons,
  aboutContent,
  aboutSlider,
  accountLogin,
  additionalProductInformation,
  animateText,
  animatedDetails,
  banner,
  basicCollection,
  bundleCarouselMobile,
  billboardSlider,
  biosSlider,
  brandCarousel,
  cluster,
  collectionProductImage,
  collectionSlider,
  columnSlider,
  comparePrice,
  compareProducts,
  contactForm,
  corpContactForm,
  faqShippingDetails,
  customerOrder,
  dynamicImageToggle,
  dynamicBackgroundToggle,
  collectionGrid,
  footer,
  freeShippingLabel,
  geolocationModal,
  itemsGroup,
  infographic,
  instagram,
  lpVideoSection,
  newsletterForm,
  newsletterSlide,
  options,
  otherProducts,
  playPauseAnimation,
  pressSlider,
  product,
  productBundle,
  productCard,
  productCardSG,
  productCardsMobile,
  productCardImages,
  productCarousel,
  productMixedBundle,
  productItem,
  productItems,
  productInfoAccordion,
  productReviewsHeader,
  productSelection,
  productSelectionGC,
  productHighlight,
  productUpsell,
  reviewsSlider,
  slider,
  smoothScroll,
  swatchButton,
  toggle,
  video,
  warrantyForm,
  privacyForm,
  window,
  price,
  productLoader,
  quantitySelector,
  oldStickyProductBar,
};

export default picoapp(components, state);
